'use client';

import dynamic from 'next/dynamic';

export const SurveyLazyMount = dynamic(() => import('./SurveyWithProviders').then((mod) => mod.SurveyWithProviders), {
  ssr: false,
  loading: () => null
});
